import { render, staticRenderFns } from "./ButtonNumberIncrementer.vue?vue&type=template&id=5cfb616e"
import script from "./ButtonNumberIncrementer.vue?vue&type=script&lang=js"
export * from "./ButtonNumberIncrementer.vue?vue&type=script&lang=js"
import style0 from "./ButtonNumberIncrementer.vue?vue&type=style&index=0&id=5cfb616e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports